import styled from 'styled-components';

const DatePickerWrapper = styled.div`
  display: flex;
  font-size: '14px';
  font-family: 'poppins, Arial, sans-serif';
`;

export default DatePickerWrapper;



// WEBPACK FOOTER //
// ./components/date-picker/styled.js